import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Dashboard = () => {
  const [kpiData, setKpiData] = useState({
    salary: '$95k',
    growth: '+24%',
    hike: '140%',
    time: '90 Days'
  });

  const [barHeights, setBarHeights] = useState([20, 25, 55, 85, 95]);
  const [donutProgress, setDonutProgress] = useState(76);

  useEffect(() => {
    const interval = setInterval(() => {
      // Animate bars
      const newHeights = barHeights.map(() => 
        Math.floor(Math.random() * (95 - 30) + 30)
      );
      setBarHeights(newHeights);

      // Animate donut
      const newProgress = Math.floor(Math.random() * (96 - 88) + 88);
      setDonutProgress(newProgress);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const circumference = 2 * Math.PI * 40;
  const strokeDashoffset = circumference - (circumference * donutProgress) / 100;

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8 }}
      className="bg-pbi-grey border border-gray-700 rounded-xl p-4 shadow-2xl relative overflow-hidden group hover:border-pbi-yellow transition-colors duration-500"
    >
      <div className="flex justify-between items-center mb-4 border-b border-gray-700 pb-2">
        <span className="text-sm font-semibold text-gray-300">My Career Analytics</span>
        <div className="flex gap-2">
          <div className="w-2 h-2 rounded-full bg-red-500"></div>
          <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
          <div className="w-2 h-2 rounded-full bg-green-500"></div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <motion.div 
          whileHover={{ scale: 1.05 }}
          className="bg-pbi-dark p-3 rounded border-l-2 border-pbi-yellow"
        >
          <p className="text-xs text-gray-400">Target Salary</p>
          <p className="text-lg font-bold text-white">{kpiData.salary}</p>
        </motion.div>
        <motion.div 
          whileHover={{ scale: 1.05 }}
          className="bg-pbi-dark p-3 rounded border-l-2 border-green-500"
        >
          <p className="text-xs text-gray-400">Job Growth</p>
          <p className="text-lg font-bold text-green-400">{kpiData.growth}</p>
        </motion.div>
        <motion.div 
          whileHover={{ scale: 1.05 }}
          className="bg-pbi-dark p-3 rounded border-l-2 border-blue-500"
        >
          <p className="text-xs text-gray-400">Avg Salary Hike</p>
          <p className="text-lg font-bold text-white">{kpiData.hike}</p>
        </motion.div>
        <motion.div 
          whileHover={{ scale: 1.05 }}
          className="bg-pbi-dark p-3 rounded border-l-2 border-purple-500"
        >
          <p className="text-xs text-gray-400">Time to Learn</p>
          <p className="text-lg font-bold text-white">{kpiData.time}</p>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-pbi-dark p-4 rounded md:col-span-2">
          <p className="text-xs text-gray-400 mb-4">Income Potential (vs Manual Labor)</p>
          <div className="flex items-end justify-between h-32 gap-2">
            {barHeights.map((height, index) => (
              <div key={index} className="w-full bg-gray-700 rounded-t h-full relative group">
                <motion.div 
                  animate={{ height: `${height}%` }}
                  transition={{ duration: 0.8, ease: "easeInOut" }}
                  className={`absolute bottom-0 w-full rounded-t ${
                    index < 2 ? 'bg-red-500' : 'bg-pbi-yellow'
                  }`}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="bg-pbi-dark p-4 rounded flex flex-col items-center justify-center">
          <p className="text-xs text-gray-400 mb-2">H1B Probability</p>
          <div className="relative w-24 h-24">
            <svg className="w-full h-full transform -rotate-90">
              <circle 
                cx="50%" 
                cy="50%" 
                fill="transparent" 
                r="40" 
                stroke="#333" 
                strokeWidth="8"
              />
              <motion.circle 
                cx="50%" 
                cy="50%" 
                fill="transparent" 
                r="40" 
                stroke="#F2C811" 
                strokeWidth="8"
                strokeDasharray={circumference}
                animate={{ strokeDashoffset }}
                transition={{ duration: 0.8, ease: "easeInOut" }}
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-sm font-bold">High</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute top-4 right-4 flex items-center gap-1 bg-black/50 px-2 py-1 rounded border border-gray-600">
        <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
        <span className="text-[10px] uppercase font-bold tracking-widest text-gray-300">
          Market Live
        </span>
      </div>
    </motion.div>
  );
};

export default Dashboard;